module.exports = __webpack_public_path__ + "static/media/energy.87783b23.svg";